import { api } from "@/services";

export const CountryStateStatus = {
  NONE: "",
  ERROR: "error",
};

export const country = {
  namespaced: true,
  state: {
    items: [],
    status: CountryStateStatus.NONE,
    error: {},
  },
  actions: {
    list({ commit, state }) {
      //* Lazy caching since countries, usually, don't suppose to change.
      if (!state.items.length) {
        commit("UNSET_ERROR");
        commit("UNSET_ITEMS");

        return api.country
          .list()
          .then((countries) => commit("SET_ITEMS", countries.data))
          .catch((error) => commit("SET_ERROR", error));
      }

      return Promise.resolve();
    },
    unsetItems({ commit }) {
      commit("UNSET_ITEMS");
    },
  },
  mutations: {
    UNSET_ITEMS(state) {
      state.items = [];
    },
    UNSET_ERROR(state) {
      state.error = {};
      state.status = CountryStateStatus.NONE;
    },
    SET_ERROR(state, error) {
      state.error = error;
      state.status = CountryStateStatus.ERROR;
    },
    SET_ITEMS(state, items) {
      let transformedItems = [];
      for (let item in items) {
        transformedItems.push({ id: item, name: items[item] });
      }
      state.items = transformedItems;
    },
  },
};

export default {
  country,
  CountryStateStatus,
};
